import React from 'react';
import PropTypes from 'prop-types';
import './CountDown.scss';

class CountDown extends React.PureComponent {
  constructor(props) {
    super(props);
    this.formattedGivenDate = new Date(this.props.givenDate);
    this.state = { msDiff: this.calculateMsDiff() };

    this.update = this.update.bind(this);
  }

  componentDidMount() {
    this.decr = setInterval(this.update, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.decr);
  }

  update() {
    this.setState({ msDiff: this.calculateMsDiff() });
    if (this.state.msDiff <= 0) {
      clearInterval(this.decr);
    }
  }

  calculateMsDiff() {
    const today = new Date();
    return this.formattedGivenDate - today;
  }

  calculateTime() {
    const days = parseInt(this.state.msDiff / (24 * 3600 * 1000), 10);
    // eslint-disable-next-line
    const hours = parseInt(this.state.msDiff / (3600 * 1000) - days * 24, 10);
    // eslint-disable-next-line
    const mins = parseInt(this.state.msDiff / (60 * 1000) - days * 24 * 60 - hours * 60, 10);
    const secs = parseInt(
      // eslint-disable-next-line
      this.state.msDiff / 1000 - mins * 60 - days * 24 * 60 * 60 - hours * 60 * 60,
      10
    );
    return { days, hours, mins, secs };
  }

  render() {
    const { days, hours, mins, secs } = this.calculateTime();

    const time =
      this.state.msDiff > 0
        ? `${days} day(s) ${hours} hour(s) ${mins} minute(s) ${secs} second(s)`
        : this.props.afterDateMessage;

    const title = this.state.msDiff > 0 ? this.props.title : null;

    return (
      <div className="countdown-container dark-helo">
        <h2>{title}</h2>
        <h2>{time}</h2>
      </div>
    );
  }
}

CountDown.propTypes = {
  afterDateMessage: PropTypes.string.isRequired,
  givenDate: PropTypes.instanceOf(Date).isRequired,
  title: PropTypes.string.isRequired
};

export default CountDown;
